import React, { useState } from 'react'
import { TokenRewardsCounter } from './TokenRewardsCounter'
import { TokenRewardsModal } from './TokenRewardsModal'
import { useApiTokenRewards } from '../../providers'
import styled from 'styled-components'

export function TokenRewards() {
  const [visible, setVisible] = useState<boolean>(false)

  const apiTokenRewards = useApiTokenRewards()

  return (
    <Container>
      {visible && <TokenRewardsModal apiTokenRewards={apiTokenRewards} onClose={() => setVisible(false)} />}
      <TokenRewardsCounter apiTokenRewards={apiTokenRewards} onClick={() => setVisible(true)} />
    </Container>
  )
}

const Container = styled.div``
